import _typeof from "babel-runtime/helpers/typeof";
function isObject(v) {
  return v !== null && v !== void 0 && (typeof v === "undefined" ? "undefined" : _typeof(v)) === "object";
}

function getSize(v) {
  return v.length !== void 0 ? v.length : v.size;
}

function isList(v) {
  return isObject(v) && getSize(v) !== void 0 && v.map && typeof v.map === 'function';
}

export function mapListOrSingle(v, f) {
  return isObject(v) ? isList(v) ? v.map(function (i) {
    return f(i);
  }) : f(v) : [];
}

export function listOrSingleSize(v) {
  return isObject(v) ? isList(v) ? getSize(v) : 1 : 0;
}

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

export function onLinkClick(evt, onClick) {
  if (evt.button === 0 && !isModifiedEvent(evt)) {
    if (!evt.defaultPrevented) {
      evt.preventDefault();
    }
    onClick();
  }
}